<div class="map-container" #map>
  <div class="placeholder"><span class="placeholder-text">La Carte s'affichera ici</span></div>
</div>
